import { Navigate, Route } from 'react-router';

import { Report, ReportRoutes } from '@app-velocity/libs/report';

import { SimulationReportRoutesPaths } from './SimulationReportRoutesPaths';

import { Confidence } from '../pages/Confidence';

import { StartReport } from '../pages/StartReport';
import { TokenProtectedRoute } from './TokenProtectedRoute';

import { SimulationAccessProtectedRoute } from './SimulationAccessProtectedRoute';
import { SimulationReport } from '../pages/SimulationReport';

const LayoutRoute = Route;

export const SimulationReportRoutes = (
  <LayoutRoute path={SimulationReportRoutesPaths.report}>
    <Route
      path={SimulationReportRoutesPaths.access}
      element={<TokenProtectedRoute inverted />}
    >
      <Route index element={<StartReport />} />
    </Route>
    <LayoutRoute element={<TokenProtectedRoute />}>
      <LayoutRoute element={<SimulationReport />}>
        <LayoutRoute element={<Report />}>
          <LayoutRoute element={<SimulationAccessProtectedRoute />}>
            <Route
              path={SimulationReportRoutesPaths.confidence}
              element={<Confidence />}
            />
          </LayoutRoute>
          {ReportRoutes}
        </LayoutRoute>
      </LayoutRoute>
    </LayoutRoute>
    <Route
      path="*"
      element={<Navigate to={SimulationReportRoutesPaths.access} />}
    />
  </LayoutRoute>
);
